import { memo } from "react";
import { Card, CardActions, CardContent, CardHeader, FormControl, MenuItem, Select, Typography } from "@mui/material";

interface SelectionCardProps {
    title: string;
    description: string;
    options: string[];
    selectedOption: string;
    setSelectedOption: (option: string) => void;
    disabled?: boolean;
}

const SelectionCard = memo(({ title, description, options, selectedOption, setSelectedOption, disabled }: SelectionCardProps) => {
    return (
        <Card>
            <CardHeader title={title} />

            <CardContent sx={{ my: -1 }}>
                <Typography>{description}</Typography>
            </CardContent>

            <CardActions>
                <FormControl fullWidth>
                    <Select 
                        value={selectedOption} 
                        onChange={(e) => setSelectedOption(e.target.value)} 
                        displayEmpty 
                        sx={{ height: 40 }} 
                        color="secondary"
                        disabled={disabled}
                    >
                        <MenuItem value="">
                            <Typography fontStyle="italic">Bitte wählen</Typography>
                        </MenuItem>

                        {options.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </CardActions>
        </Card>
    );
});

export default SelectionCard;
